import { AddPaymentForm } from '@/billing/components/add-payment-form';

import { Modal } from '@scripsteam/scrips-signal-ds';
/**
 * Modal wrapper around the shared `AddPaymentForm`, for surfaces where the
 * add-payment flow is launched from a row action rather than shown inline —
 * i.e. the patient-module invoice list (Flutter's patient
 * `add_payment_popup.dart` is also a popup). View Claim and appointment→billing
 * render `AddPaymentForm` inline instead.
 *
 * Same fields + wire body as everywhere else (Cash/Card/Bank/Balance +
 * Pay-in-full/Other). Closes after a successful record.
 */
interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invoiceId: string;
  patientPayable: number;
  patientOutstanding?: number;
  availableBalance?: number;
  /** Fired after a successful record (before the dialog closes) — hosts refresh
   *  their own caches (e.g. patient-billing) that `useAddPayment` doesn't touch. */
  onSuccess?: () => void;
  onCashierShiftRequired?: () => void;
}

export function AddPaymentDialog({
  open,
  onOpenChange,
  invoiceId,
  patientPayable,
  patientOutstanding,
  availableBalance,
  onSuccess,
  onCashierShiftRequired,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={() => onOpenChange(false)}
      title="Receive Payment"
      description="Record a payment received from the patient toward this invoice."
      size="lg"
      variant="bleed"
    >
        
        <div className="p-4">
          <AddPaymentForm
            invoiceId={invoiceId}
            patientPayable={patientPayable}
            patientOutstanding={patientOutstanding}
            availableBalance={availableBalance}
            approveLabel="Approve Payment"
            onCashierShiftRequired={onCashierShiftRequired}
            onSuccess={() => {
              onSuccess?.();
              onOpenChange(false);
            }}
          />
        </div>
      </Modal>
  );
}
